/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable radix */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable camelcase */
/* eslint-disable object-curly-newline */
import React, {
  useState, useContext, useEffect, useRef, useMemo
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import {
  APPLICATION_STATE,
  ApplicationContext
} from '@apps/contexts/ApplicationContext'
import { PLANS_STATE } from '@apps/redux/features/PlansSlice'
import { PHONE_NUMBER_STATE } from '@apps/redux/features/PhoneNumberSlice'
import AccountHelpers, {
  convertCentsToDollars,
  PROMO_CRITERIA
} from '@apps/flows/activation/services/accountHelper'
import { getById, getBySlug } from '@apps/utils/contentful'
import { Input, Chip, ControlledModal, Button, Typography } from '@telus/koodo-ui-kit'
import Sites from '@sites/index'

import PaymentChangeHandlers, {
  PAYMENT_EVENTS
} from '@apps/utils/ChangeHandlers/PaymentChangeHandlers'
import { ANALYTICS_EVENT_TYPES } from '@apps/utils/constants'
import { setPageAnalytics } from '@apps/utils/Analytics'
import { getPromoNames } from '@apps/utils/common'
import { carriesBothLocales } from '@apps/utils/promoBundle'
import { PAYMENT_STATE, updatePaymentStates } from '../../redux/features/PayAndReviewSlice'
import { getPromotionAndValidationCodes } from '@/apps/utils/requestPayloadHelper'

import BodyError from '../Typography/BodyError'
import useTagManagerInfo from '../../../_engine/hooks/useTagManagerInfo'

const MultiPromoCode = (props) => {

  const { onComplete } = props
  const dispatch = useDispatch()
  const location = useLocation()
  const {
    [APPLICATION_STATE.SERVICES]: brandServices,
    [APPLICATION_STATE.IDENTITY]: identity,
    [APPLICATION_STATE.CURRENT_LANGUAGE]: currentLanguage,
    [APPLICATION_STATE.CURRENT_REGION]: region,
    [APPLICATION_STATE.PROVINCES]: provinces
  } = useContext(ApplicationContext)

  const {
    content: { pageContent, featureFlags },
    user: { selectedLanguage },
    userType
  } = useSelector((state) => state.common)

  const pagePrefix = userType === Sites.dealer ? 'Dealer' : 'Consumer'

  const tagManagerInfo = useTagManagerInfo()

  // eslint-disable-next-line camelcase
  const pushClickAnalytics = ({ click_text, promoCodeDescription, event_type, target_link, automatic_top_up, field_warning, error_response_code, event_click = ANALYTICS_EVENT_TYPES.CLICK } = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      setPageAnalytics(location, 'click', region, currentLanguage, {
        ...tagManagerInfo,
        click_text,
        field_warning,
        error_response_code,
        automatic_top_up,
        promoCodeDescription
      }, event_type, event_click, target_link)
    )
  }

  const paymentPage = getById(pageContent, `paymentPage${pagePrefix}`)?.[currentLanguage]

  const textContent = useMemo(() => {
    if (!paymentPage) return {}
    const { shortTextFields } = paymentPage
    return {
      add: getBySlug(shortTextFields, 'add')?.value,
      applyPromotion: getBySlug(shortTextFields, 'applyPromotion')?.value,
      promoTitle: getBySlug(shortTextFields, 'promo')?.value,
      promoCodeText: getBySlug(shortTextFields, 'promoCodeText')?.value,
      ratePlanPage: getBySlug(shortTextFields, 'ratePlanPage')?.value,
      ratePlanPageLink: getBySlug(shortTextFields, 'ratePlanPageLink')?.value,
      enterPromoCode: getBySlug(shortTextFields, 'enterPromoCode')?.value,
      enterValidationCode: getBySlug(shortTextFields, 'enterValidationCode')?.value,
      promotionCodeInvalid: getBySlug(shortTextFields, 'promotionCodeInvalidTryAgain')?.value,
      validationCodeInvalid: getBySlug(shortTextFields, 'validationCodeInvalidTryAgain')?.value,
      validatePromoTitle: getBySlug(shortTextFields, 'validatePromoTitle')?.value,
      validatePromoSubTitle: getBySlug(shortTextFields, 'validatePromoSubTitle')?.value,
      promoAlreadyExists: getBySlug(shortTextFields, 'promoAlreadyExists')?.value,
      provinceRequired: getBySlug(shortTextFields, 'provinceRequired')?.value
    }
  }, [paymentPage, currentLanguage])

  const {
    add,
    applyPromotion,
    promoTitle,
    promoCodeText,
    enterPromoCode,
    enterValidationCode,
    promotionCodeInvalid,
    validationCodeInvalid,
    validatePromoTitle,
    validatePromoSubTitle,
    promoAlreadyExists,
    provinceRequired
  } = textContent

  const { [PLANS_STATE.PLAN]: plansInfo } = useSelector((state) => state.plansPage)

  const paymentState = useSelector((state) => state.payAndReviewPage)

  const content = useMemo(() => {
    const paymentPageContent = getById(pageContent, `paymentPage${pagePrefix}`)?.[selectedLanguage]
    return {
      atuPromoCodeValue: getBySlug(paymentPageContent?.shortTextFields, 'atuPromoCode')?.value,
    }
  }, [pageContent, selectedLanguage])

  const pageContentByLang = {
    en: getById(pageContent, `plansPage${pagePrefix}`)?.en,
    fr: getById(pageContent, `plansPage${pagePrefix}`)?.fr
  }
  const shortTextFields = {
    en: pageContentByLang.en?.shortTextFields || [],
    fr: pageContentByLang.fr?.shortTextFields || []
  }
  const autoPromoText = {
    en: getBySlug(shortTextFields.en, 'autoPromoText')?.value,
    fr: getBySlug(shortTextFields.fr, 'autoPromoText')?.value,
  }

  // Multiple Promo Declarations
  const { findAndValidatePromotions } = brandServices
  const [promoCodeError, setPromoCodeError] = useState('')
  const [isValidPromoCode, setIsValidPromoCode] = useState(false)
  const [atuPromoCode, setATUPromoCode] = useState('')
  const [atuPromoEnabled, setATUPromoEnabled] = useState(false)
  const [atuApplied, setATUApplied] = useState(false)
  const [isPromoCodeLoading, setIsPromoCodeLoading] = useState(false)
  const [isPromoValidationRequired, setIsPromoValidationRequired] = useState(false)
  const [isValidPromoValidationCode, setIsValidPromoValidationCode] = useState(false)
  const [promoCodeValidationError, setPromoCodeValidationError] = useState('')
  const [isPromoValidationCodeLoading, setIsPromoValidationCodeLoading] = useState(false)
  const [multiPromoMaxLimitMessage, setMultiPromoMaxLimitMessage] = useState(null)
  const [multiPromoMaxLimit, setMultiPromoMaxLimit] = useState(null)
  const [exclusivePromoCodeError, setExclusivePromoCodeError] = useState('')
  const [reapplyExistingPromoCodeError, setReapplyExistingPromoCodeError] = useState('')
  const [, setAdding] = useState(false)

  const reapplyExistingPromoCodeErrorRef = useRef(reapplyExistingPromoCodeError)
  const exclusivePromoCodeErrorRef = useRef(exclusivePromoCodeError)
  const addPromoButtonRef = useRef(null)


  const {
    [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE]: multiPromotionCode,
    [PAYMENT_STATE.PROMO.MULTI_PROMOTION_VALIDATION_CODE]: multiPromotionValidationCode,
    [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_INFO]: multiPromotionCodeInfo,
    [PAYMENT_STATE.PROMO.MULTI_PROMO_CODES]: multiPromoCodes,
    [PAYMENT_STATE.AUTO_TOP_UPS]: autoTopUps,
    [PAYMENT_STATE.SUMMARY.TAX_PROVINCE]: taxProvince,
    [PAYMENT_STATE.SUMMARY.TAX_PROVINCE_ID]: taxProvinceId
  } = paymentState

  const phoneNumberState = useSelector((state) => state.phoneNumberPage)
  const phoneProvinceId = phoneNumberState?.[PHONE_NUMBER_STATE.PROVINCE_ID]
  const promoProvince = useMemo(() => {
    // taxProvince is already a short code, but the *Id fields hold backend
    // province ids (UUIDs) which findAndValidatePromotions does not accept —
    // resolve those through the provinces list, as LocationSelector does before
    // display. Falling through to an unresolved id has the promo rejected as
    // ineligible for the plan.
    const toShortName = (value) => {
      if (!value) return ''
      const raw = String(value).trim()
      if (raw.length <= 3) return raw
      return provinces?.find((province) => String(province?.value) === raw)?.shortName || ''
    }

    const candidate = toShortName(taxProvince)
      || toShortName(phoneProvinceId)
      || toShortName(taxProvinceId)
    if (!candidate) return ''
    const normalized = candidate.toUpperCase()
    return normalized === 'NL' ? 'NF' : normalized
  }, [taxProvince, phoneProvinceId, taxProvinceId, provinces])

  useEffect(() => {
    if (
      (isValidPromoCode && !isPromoValidationRequired) ||
      (isValidPromoCode && isPromoValidationRequired && isValidPromoValidationCode) ||
      (!isValidPromoCode && promoCodeError)
    ) {
      onComplete && onComplete()
    } else {
      const timer = setTimeout(() => {
        onComplete && onComplete()
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [
    isValidPromoCode,
    isPromoValidationRequired,
    isValidPromoValidationCode,
    promoCodeError,
    paymentState.multiPromotionCodeInfo,
    paymentState.multiPromoCodes
  ])

  const updatePaymentStore = (payload) => {
    dispatch(updatePaymentStates(payload))
  }

  useEffect(() => {
    if (
      (isValidPromoCode && isPromoValidationRequired && isValidPromoValidationCode) ||
      (isValidPromoCode && !isPromoValidationRequired)
    ) {
      removePCode()
    }
  }, [taxProvince, plansInfo])

  useEffect(() => {
    if (!paymentPage) return

    const { shortTextFields } = paymentPage

    const maxLimitField = getBySlug(shortTextFields, 'multiPromoMaxLimit')
    const maxLimitMessageField = getBySlug(shortTextFields, 'multiPromoMaxLimitMessage')
    const exclusivePromoErrorField = getBySlug(shortTextFields, 'exclusivePromoErrorMessage')
    const reapplyExistingPromoErrorField = getBySlug(shortTextFields, 'reapplyExistingPromoCodeErrorMessage')
    const atuPromoCodeValue = content?.atuPromoCodeValue

    const isATUPromoEnabled = featureFlags[0].isAtuPromoEnabled

    const limitValue = parseInt(maxLimitField?.value || '', 10)

    setATUPromoCode(atuPromoCodeValue)
    setATUPromoEnabled(!!isATUPromoEnabled)
    setMultiPromoMaxLimit(Number.isNaN(limitValue) ? null : limitValue)
    setMultiPromoMaxLimitMessage(maxLimitMessageField?.value || null)

    const exclusiveErrorMessageValue = exclusivePromoErrorField?.value || ''
    setExclusivePromoCodeError(exclusiveErrorMessageValue)
    exclusivePromoCodeErrorRef.current = exclusiveErrorMessageValue

    const reapplyErrorMessageValue = reapplyExistingPromoErrorField?.value || ''
    setReapplyExistingPromoCodeError(reapplyErrorMessageValue)
    reapplyExistingPromoCodeErrorRef.current = reapplyErrorMessageValue
  }, [paymentPage, content?.atuPromoCodeValue, currentLanguage, featureFlags])

  const mounted = useRef(false)
  /* istanbul ignore next */
  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true
      return
    }

    if (!promoCodeError) return
    validatePromoCodeOnLanguageChange()

  }, [currentLanguage])

  useEffect(() => {
    if (promoCodeError === reapplyExistingPromoCodeError) {
      setPromoCodeError(reapplyExistingPromoCodeError)
    }
  }, [reapplyExistingPromoCodeError])

  const isSamePromoCode = (promoCode, code) => {
    return !!promoCode && !!code && code === promoCode
  }

  useEffect(() => {
    // Gate on the same province addPromoCode sends, not on taxProvince alone:
    // switching the payment option resets the summary block (taxProvince
    // included), so re-checking auto top-up would otherwise never re-apply the
    // promo even though promoProvince still resolves from the phone number.
    if (
      !atuApplied &&
      atuPromoEnabled &&
      autoTopUps &&
      !!promoProvince &&
      !!plansInfo?.id &&
      !!atuPromoCode
    ) {
      const verify = async () => {
        await addPromoCode(atuPromoCode, { hidePromoCodeError: true })
        setATUApplied(true)
      }
      verify()
    }
  }, [
    atuApplied,
    atuPromoEnabled,
    atuPromoCode,
    autoTopUps,
    promoProvince,
    plansInfo?.id
  ])

  useEffect(() => {
    if (!autoTopUps && atuPromoEnabled) {
      const atuPromoCodeIndex = multiPromoCodes?.findIndex((code) => isSamePromoCode(atuPromoCode, code))
      if (atuPromoCodeIndex > -1) {
        removePCode(atuPromoCodeIndex)
        setATUApplied(false)
      }
    }
  }, [autoTopUps, atuPromoCode, atuPromoEnabled])

  // The promo limit counts manually entered codes only, so the plan's auto promo
  // and the ATU promo are both excluded. autoPromoText is a localized
  // `{ en, fr }` object, so it has to be compared per locale — passing the object
  // itself compares a string to an object, never matches, and left the auto promo
  // counting toward the limit, costing the user their fifth manual code.
  const manualMultiPromoCodes = useMemo(() => {
    return multiPromoCodes.filter((code) => (
      !isSamePromoCode(atuPromoCode, code)
      && !isSamePromoCode(autoPromoText.en, code)
      && !isSamePromoCode(autoPromoText.fr, code)
    ))
  }, [multiPromoCodes.length, atuPromoCode, autoPromoText.en, autoPromoText.fr])

  const isMaxPromoLimitReached =
    multiPromoMaxLimit && multiPromoMaxLimit === manualMultiPromoCodes.length

  // Locale the promo records in the store were fetched for, so a real EN/FR
  // switch can be told apart from this effect's first run on mount.
  const promoCopyLocaleRef = useRef(currentLanguage)

  useEffect(() => {
    const languageChanged = promoCopyLocaleRef.current !== currentLanguage
    // Track the locale on every switch, not just the ones with a promo applied:
    // a switch made while the cart was empty would otherwise leave the ref
    // stale, and the next toggle would look like a first run and take the
    // shortcut — leaving a single-locale record in the previous language.
    promoCopyLocaleRef.current = currentLanguage

    if (multiPromotionCodeInfo.length > 0) {
      updateMultiPromoLanguage({ languageChanged })
    }
  }, [currentLanguage])

  const getMultiPromoCodesForCurrentLanguage = () => {
    const currMultiPromoCodes = [...multiPromoCodes]
    if (plansInfo?.promo && multiPromoCodes.length > 0) {
      const autoPromoIndex = currMultiPromoCodes.findIndex(
        code => code === autoPromoText.en || code === autoPromoText.fr
      )

      if (autoPromoIndex !== -1) {
        currMultiPromoCodes[autoPromoIndex] = autoPromoText[selectedLanguage]
      }
    }
    return currMultiPromoCodes
  }

  const updateMultiPromoLanguage = async ({ languageChanged = false } = {}) => {
    const currMultiPromoCodes = getMultiPromoCodesForCurrentLanguage()
    const multiPromotionAndValidationCodes = getPromotionAndValidationCodes(currMultiPromoCodes)

    // On mount there is nothing to re-word — the records are already in the
    // active locale — so swapping the code string is enough.
    //
    // After a real switch the records themselves have to change language. The
    // plan's auto promo carries both locales, so when it is the only applied
    // code the order summary can be re-worded straight from the store. Manual
    // and ATU promos come back from findAndValidatePromotions in the requested
    // locale only, so anything else applied — or a record carrying one locale,
    // as when the French copy was never authored — still needs re-validating.
    const canReWordFromStore = multiPromotionAndValidationCodes === autoPromoText[selectedLanguage]
      && currentLanguage === selectedLanguage
      && (!languageChanged || multiPromotionCodeInfo.every(carriesBothLocales))

    if (canReWordFromStore) {
      updatePaymentStore({
        multiPromoCodes: currMultiPromoCodes
      })
      return
    }

    // promoProvince, not taxProvince: switching the payment option resets the
    // summary block and clears taxProvince, and sending an empty province makes
    // the backend report otherwise-valid promos as ineligible for the plan.
    const { data } = await findAndValidatePromotions(
      plansInfo.id,
      promoProvince,
      currentLanguage,
      identity?.channelOrgCode,
      multiPromotionAndValidationCodes
    )
    const allHaveIds = data.every(
      (promotion) => promotion.id !== undefined && promotion.id !== null
    )
    if (allHaveIds) {
      const newMultiPromotionCodeInfo = data?.map((promo) => {
        const bundleArray = promo?.bundles?.map((bundle) => {
          const {
            id, name, fee: rawFee, bundleType, unitType, numberMrc
          } = bundle
          return {
            id,
            name,
            fee: convertCentsToDollars(rawFee),
            bundleType,
            unitType,
            numberMrc
          }
        })
        return {
          id: promo.id,
          description: promo.description,
          bundles: bundleArray
        }
      })
      updatePaymentStore({
        multiPromotionCodeInfo: newMultiPromotionCodeInfo
      })
    }
  }

  useEffect(() => {
    const newState = {
      multiPromotionCode: '',
      multiPromotionValidationCode: ''
    }

    updatePaymentStore(newState)

    setIsValidPromoCode(false)
    setIsValidPromoValidationCode(false)
  }, [isValidPromoCode, isValidPromoValidationCode])

  const validatePromoCodeFields = (value) => {
    if (!value) setPromoCodeError(enterPromoCode)
    else setPromoCodeError('')
  }

  const validatePromoCodeValidationFields = (value) => {
    if (!value) setPromoCodeValidationError(enterValidationCode)
    else setPromoCodeValidationError('')
  }

  const removePCode = (index) => {
    const newTagList = multiPromoCodes.filter((_, i) => i !== index)
    const newMultiPromotionCodeInfo = multiPromotionCodeInfo.filter((_, i) => i !== index)

    setIsValidPromoCode(false)
    setIsValidPromoValidationCode(false)
    setIsPromoValidationRequired(false)

    updatePaymentStore({
      ...paymentState,
      multiPromotionCodeInfo: newMultiPromotionCodeInfo,
      multiPromoCodes: newTagList
    })

    pushClickAnalytics({ click_text: 'close icon - remove promo code', promoCodeDescription: getPromoNames(newMultiPromotionCodeInfo), event_type: 'remove promo code onclick of close icon' })
  }

  const addPromoCode = async (code, opts) => {
    if (addPromoButtonRef.current) {
      addPromoButtonRef.current.blur()
    }
    const promoCode = code.includes(':') ? code : code?.trim().toUpperCase()
    validatePromoCodeFields(promoCode)
    if (promoCode) {
      if (!promoProvince) {
        pushClickAnalytics({ click_text: 'Province is missing', field_warning: provinceRequired, promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'Missing province information' })
        setPromoCodeError(provinceRequired)
        return
      }
      if (!plansInfo.id) {
        pushClickAnalytics({ click_text: 'Select plan', field_warning: 'Please select a plan to continue', promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'Select a valid plan' })
        setPromoCodeError('Please select a plan to continue')
        return
      }

      updatePaymentStore({ [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_LOADER]: true })
      setIsPromoCodeLoading(true)

      const existingPromoAndValCodes = getPromotionAndValidationCodes(multiPromoCodes)
      const multiPromotionAndValidationCodes = [
        ...existingPromoAndValCodes.split(';').filter((e) => e),
        promoCode
      ].join(';')

      const data = [
        plansInfo.id,
        identity?.channelOrgCode,
        promoProvince,
        multiPromotionAndValidationCodes,
        currentLanguage
      ]
      const dupes = (multiPromoCodes || []).filter((atag) => {
        return typeof atag === 'string' && (atag?.split('-') ? atag?.split('-')[0] : atag) === promoCode
      }).length
      if (dupes > 0) {
        setPromoCodeError(`${promoAlreadyExists}`)
        updatePaymentStore({ [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_LOADER]: false })
        setIsPromoCodeLoading(false)
        setAdding(false)
        return
      }
      const promo = await AccountHelpers.findAndValidatePromoCode(
        findAndValidatePromotions,
        ...data
      )
      if (promo) {
        if (promo?.bundles?.length > 0) pushClickAnalytics({ click_text: 'Add promo click', promoCodeDescription: getPromoNames([...multiPromotionCodeInfo, promo]), event_type: 'Promo added successfully' })
        if (promo.code && promo.code === PROMO_CRITERIA.EXCLUSIVE_PROMO_CONFLICT) {
          setIsValidPromoCode(false)
          setPromoCodeError(exclusivePromoCodeErrorRef.current)
          updatePaymentStore({ [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_LOADER]: false })
          setIsPromoCodeLoading(false)
          setAdding(false)
          pushClickAnalytics({ click_text: 'Exclusive promotion error', field_warning: exclusivePromoCodeErrorRef.current, error_response_code: PROMO_CRITERIA.EXCLUSIVE_PROMO_CONFLICT, promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'Exclusive promotion error' })
          return
        }

        if (promo.code && promo.code === PROMO_CRITERIA.REAPPLY_EXISTING_PROMOTION_ERROR) {
          setIsValidPromoCode(false)
          setPromoCodeError(reapplyExistingPromoCodeErrorRef.current)
          updatePaymentStore({ [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_LOADER]: false })
          setIsPromoCodeLoading(false)
          setAdding(false)
          pushClickAnalytics({ click_text: 'Reapply existing promo error', field_warning: reapplyExistingPromoCodeErrorRef.current, error_response_code: PROMO_CRITERIA.REAPPLY_EXISTING_PROMOTION_ERROR, promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'Reapply existing promotion error' })
          return
        }

        if (promo.code && promo.code === PROMO_CRITERIA.VALIDATION_CODE) {
          setIsPromoValidationRequired(true)
          setIsValidPromoValidationCode(false)
          setIsValidPromoCode(false)
          updatePaymentStore({ [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_LOADER]: false })
          setIsPromoCodeLoading(false)
          setAdding(false)
          return
        }
        setIsValidPromoCode(true)

        const newState = {
          multiPromotionCodeInfo: [...paymentState.multiPromotionCodeInfo, promo],
          multiPromoCodes: [...paymentState.multiPromoCodes, promoCode],
          multiPromotionCode: promoCode // Check if promo code is atu?
        }
        updatePaymentStore(newState)

      } else if (opts?.hidePromoCodeError) {
        setPromoCodeError('')
      } else {
        setPromoCodeError(promotionCodeInvalid)
        pushClickAnalytics({ click_text: 'promo code is not valid', field_warning: promotionCodeInvalid, error_response_code: '404', promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'Invalid promo code' })

      }
      setTimeout(() => {
        updatePaymentStore({ [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_LOADER]: false })
      }, 1000)
      setIsPromoCodeLoading(false)
      setAdding(false)
    }
  }
  /* istanbul ignore next */
  const validatePromoCodeOnLanguageChange = async () => {
    validatePromoCodeFields(multiPromotionCode)
    if (multiPromotionCode) {
      if (!promoProvince) {
        setPromoCodeError(provinceRequired)
        return
      }
      if (!plansInfo.id) {
        setPromoCodeError('Please select a plan to continue')
        return
      }

      updatePaymentStore({ [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_LOADER]: true })
      setIsPromoCodeLoading(true)

      const existingPromoAndValCodes = getPromotionAndValidationCodes(multiPromoCodes)
      const multiPromotionAndValidationCodes = [
        ...existingPromoAndValCodes.split(';').filter((e) => e),
        multiPromotionCode
      ].join(';')

      const data = [
        plansInfo.id,
        identity?.channelOrgCode,
        promoProvince,
        multiPromotionAndValidationCodes,
        currentLanguage
      ]
      const dupes = (multiPromoCodes || []).filter((atag) => {
        return typeof atag === 'string' && (atag?.split('-') ? atag?.split('-')[0] : atag) === multiPromotionCode
      }).length
      if (dupes > 0) {
        setIsPromoCodeLoading(false)
        setAdding(false)
        return
      }
      const promo = await AccountHelpers.findAndValidatePromoCode(
        findAndValidatePromotions,
        ...data
      )
      if (promo) {
        if (promo?.bundles?.length > 0) pushClickAnalytics({ promoCodeDescription: getPromoNames([...multiPromotionCodeInfo, promo]), event_type: 'Add promo on language change' })
        if (promo.code && promo.code === PROMO_CRITERIA.EXCLUSIVE_PROMO_CONFLICT) {
          setIsValidPromoCode(false)
          setPromoCodeError(exclusivePromoCodeErrorRef.current)
          updatePaymentStore({ [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_LOADER]: false })
          setIsPromoCodeLoading(false)
          setAdding(false)
          return
        }

        if (promo.code && promo.code === PROMO_CRITERIA.REAPPLY_EXISTING_PROMOTION_ERROR) {
          setIsValidPromoCode(false)
          setPromoCodeError(reapplyExistingPromoCodeErrorRef.current)
          updatePaymentStore({ [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_LOADER]: false })
          setIsPromoCodeLoading(false)
          setAdding(false)
          return
        }

        if (promo.code && promo.code === PROMO_CRITERIA.VALIDATION_CODE) {
          setIsPromoValidationRequired(true)
          setIsValidPromoValidationCode(false)
          setIsValidPromoCode(false)
          updatePaymentStore({ [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_LOADER]: false })
          setIsPromoCodeLoading(false)
          setAdding(false)
          return
        }
      } else {
        setPromoCodeError(promotionCodeInvalid)
        pushClickAnalytics({ click_text: 'Promo code is invalid', field_warning: promotionCodeInvalid, error_response_code: '404', promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'Invalid promo code' })
      }
      setTimeout(() => {
        updatePaymentStore({ [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_LOADER]: false })
      }, 1000)
      setIsPromoCodeLoading(false)
      setAdding(false)
    }
  }
  /* istanbul ignore next */

  const addValidationCode = async () => {
    validatePromoCodeValidationFields(multiPromotionValidationCode)
    if (multiPromotionValidationCode) {
      setIsPromoValidationCodeLoading(true)

      const existingPromoAndValCodes = getPromotionAndValidationCodes(multiPromoCodes)
      const multiPromoAndValCode = `${multiPromotionCode}-${multiPromotionValidationCode}`
      const multiPromotionAndValidationCodes = [
        ...existingPromoAndValCodes.split(';').filter((e) => e),
        multiPromoAndValCode
      ].join(';')

      const data = [
        plansInfo.id,
        identity?.channelOrgCode,
        promoProvince,
        multiPromotionAndValidationCodes,
        currentLanguage
      ]

      const promoValidation = await AccountHelpers.findAndValidatePromoCode(
        findAndValidatePromotions,
        ...data
      )
      if (promoValidation) {
        if (promoValidation?.bundles?.length > 0) pushClickAnalytics({ click_text: applyPromotion, promoCodeDescription: getPromoNames([...multiPromotionCodeInfo, promoValidation]), event_type: 'Apply Promotion With Validation Code' })
        if (promoValidation.code && promoValidation.code === PROMO_CRITERIA.REAPPLY_EXISTING_PROMOTION_ERROR) {
          setPromoCodeValidationError(reapplyExistingPromoCodeErrorRef.current)
          setIsPromoValidationCodeLoading(false)
          return
        }
        if (
          !promoValidation.code ||
          (promoValidation.code && promoValidation.code !== 'VALIDATION_CODE')
        ) {
          setIsValidPromoValidationCode(true)
          setIsPromoValidationRequired(false)
          const newState = { ...paymentState }
          newState.multiPromotionValidationCode = multiPromotionValidationCode
          newState.multiPromotionCodeInfo = [...newState.multiPromotionCodeInfo, promoValidation]
          newState.multiPromoCodes = [...newState.multiPromoCodes, `${multiPromotionCode}-${multiPromotionValidationCode}`]
          updatePaymentStore({
            ...newState
          })
          setIsValidPromoCode(true)
        } else {
          setPromoCodeValidationError(validationCodeInvalid)
          pushClickAnalytics({ click_text: 'Validation code invalid', field_warning: validationCodeInvalid, error_response_code: '404', promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'Invalid promo validation code' })
        }
      } else {
        setPromoCodeValidationError(validationCodeInvalid)
        pushClickAnalytics({ click_text: 'Validation code invalid', field_warning: validationCodeInvalid, error_response_code: '404', promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'Invalid promo validation code' })

      }
      setIsPromoValidationCodeLoading(false)
    }
  }

  const closePopup = () => {
    pushClickAnalytics({ click_text: 'close validation popup icon', promoCodeDescription: getPromoNames(multiPromotionCodeInfo), event_type: 'close validation code popup' })
    setIsPromoValidationRequired(false)
    const newState = { ...paymentState }
    newState.multiPromotionValidationCode = ''
    updatePaymentStore({
      ...newState
    })
    if (promoCodeValidationError) setPromoCodeValidationError('')
  }

  const shouldDisplayPromo = (tag) => {
    if (isSamePromoCode(atuPromoCode, tag)) {
      return !atuPromoEnabled
    }

    const isAutoPromo = isSamePromoCode(autoPromoText.en, tag) ||
      isSamePromoCode(autoPromoText.fr, tag)

    return !isAutoPromo
  }

  const getAddButtonTokens = (state) => {
    return state.inactive ? {} : { backgroundColor: '#000000', color: '#ffffff', borderColor: '#000000' }
  }

  return (
    <>
      <div className="w-full space-y-4">
        <div className="flex flex-col items-start space-x-0 space-y-4 lg:space-y-0 md:space-y-0 md:space-x-4 lg:space-x-4 md:flex-row lg:flex-row">
          <div className="flex flex-col flex-1 w-full space-y-4">
            <div className="flex flex-col flex-1">
              <div className="flex flex-row w-full">
                <div className="flex flex-col flex-1">
                  <div className="flex flex-col md:flex-row w-full items-start flex-1 gap-4 md:gap-6">
                    <div className="flex flex-col flex-1 w-full">
                      <Input
                        label={promoTitle}
                        hint={promoCodeText}
                        id="promoCode"
                        value={multiPromotionCode}
                        onChange={(value) => {
                          PaymentChangeHandlers[PAYMENT_EVENTS.VALIDATE_CODE].onChange(
                            value,
                            validatePromoCodeFields,
                            PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE,
                            updatePaymentStore
                          )
                        }}
                        onFocus={() => setPromoCodeError('')}
                        feedback={promoCodeError}
                        validation={promoCodeError ? 'error' : undefined}
                        maxLength={30}
                        disabled={isMaxPromoLimitReached}
                        testId="payment-multipromoInput"
                      />
                    </div>
                    <div className="w-full sm:w-auto sm:self-end flex flex-col">
                      <Button
                        ref={addPromoButtonRef}
                        onPress={() => addPromoCode(multiPromotionCode)}
                        accessibilityRole="button"
                        inactive={isMaxPromoLimitReached || isPromoCodeLoading}
                        disabled={isMaxPromoLimitReached}
                        loading={isPromoCodeLoading}
                        variant={{ width: 'full' }}
                        tokens={(state) => getAddButtonTokens(state)}
                        testId="payment-promoButton"
                      >
                        {add}
                      </Button>
                      {promoCodeError && <div className="h-12" aria-hidden="true" />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          {multiPromoMaxLimitMessage && isMaxPromoLimitReached && (
            <div className="flex items-center">
              <BodyError className="ml-1 mb-0.5 leading-4">{multiPromoMaxLimitMessage}</BodyError>
            </div>
          )}
          <div className="mt-2 flex flex-wrap gap-2">
            {multiPromoCodes?.map((tag, index) => {
              if (!shouldDisplayPromo(tag)) return null

              if (typeof tag !== 'string') return null

              const tagText = tag?.split('-') ? tag?.split('-')[0] : tag

              return (
                <Chip
                  key={tag}
                  label={tagText}
                  onDismiss={() => removePCode(index)}
                  dismissLabel="Remove promo code"
                  testId={`remove-promo-code-${index}`}
                />
              )
            })}
          </div>
        </div>
      </div>

      {/* Multipromo Validation Code Pop Up */}
      <ControlledModal isOpen={isPromoValidationRequired} onClose={closePopup} data-testid="promo-validation-popup">
        <div className="p-4">
          <div className="pb-4">
            <Typography variant={{ size: 'h6' }}>{validatePromoSubTitle}</Typography>
          </div>
          <Input
            label={validatePromoTitle}
            id="validationCode"
            value={multiPromotionValidationCode}
            onChange={(value) => {
              PaymentChangeHandlers[PAYMENT_EVENTS.VALIDATE_CODE].onChange(
                value,
                validatePromoCodeValidationFields,
                PAYMENT_STATE.PROMO.MULTI_PROMOTION_VALIDATION_CODE,
                updatePaymentStore
              )
            }}
            feedback={promoCodeValidationError}
            validation={promoCodeValidationError ? 'error' : undefined}
            onFocus={() => setPromoCodeValidationError('')}
            maxLength={30}
            testId="payment-promoValidationInput"
          />
          <div className="mt-8">
            <Button
              onPress={addValidationCode}
              inactive={isPromoValidationCodeLoading || !!promoCodeValidationError}
              loading={isPromoValidationCodeLoading}
              variant={{ width: 'full' }}
              testId="payment-submitValidationInput"
            >
              {applyPromotion}
            </Button>
          </div>
        </div>
      </ControlledModal>
    </>
  )
}
export default MultiPromoCode
